// 10 minute at milliseconds
export const KEEP_ALIVE_TIME = 600000;



// WEBPACK FOOTER //
// ./src/constants/user.js